<template>
	<el-container>
		<el-header class="title">
			<el-row type="flex" align="middle">
				<el-col :span="22" >
					<el-breadcrumb separator-class="el-icon-arrow-right">
						<el-breadcrumb-item >首页</el-breadcrumb-item>
						<el-breadcrumb-item :to="{ path: '/index/productnotice' }">产品公告管理</el-breadcrumb-item>
						<el-breadcrumb-item>编辑</el-breadcrumb-item>
					</el-breadcrumb>
				</el-col>
			</el-row>
		</el-header>
		<el-main style="position: relative;" v-loading="loading">
			<el-form :model="productNotice" :rules="rules" ref="form"
							 label-width="100px" size="medium" :style="mainStyleObject" >
				<el-form-item label="标题" prop="title" >
					<el-input v-model="productNotice.title" style="width: 550px;"></el-input>
				</el-form-item>
				<el-form-item label="发布日期" prop="publishtime" >
					<el-date-picker
						align="right"
						type="date"
						placeholder="请选择发布日期"
						v-model="productNotice.publishtime"
						value-format="yyyy-MM-dd" style="width: 550px;"
					></el-date-picker>
				</el-form-item>
				<el-form-item label="所属产品" prop="productId" >
					<el-select v-model="productNotice.productId" placeholder="请选择" style="width: 550px;">
						<el-option
							v-for="item in productList"
							:key="item.id"
							:label="item.name"
							:value="item.id">
						</el-option>
					</el-select>
				</el-form-item>
				<el-form-item label="公告相关文件" prop="notileFileList" >
					<el-upload style="width: 550px;"
										 :action="getUploadUrl()"
										 :file-list="fileList"
										 :on-remove = "removeSuccess"
										 :on-success="uploadSuccess">
						<el-button size="small" type="primary">点击上传</el-button>
					</el-upload>
				</el-form-item>
				<el-form-item label="公告内容" prop="description" >
					<el-input type="textarea" :autosize="{ minRows:10,maxRows:15}" v-model="productNotice.description" style="width: 550px;"></el-input>
				</el-form-item>
			</el-form>
		</el-main>
		<div style="line-height: 40px;background:#fff;border-top: 1px solid #ddd;padding: 5px 10px 0 10px;">
			<el-button type="primary" size="small" @click="submit()" style="width: 80px;">确定</el-button>
		</div>
	</el-container>
</template>

<script>
	import config from "../../../config/global.js";
	import axios from "axios"

	var uploadUrl = config.host+"/backend/uploadextfile";
	var getProductNoticeDetailUrl = config.host + "/backend/productnotice/get.json";

    export default {
    	name: "edit-product-notice",
			data:function () {
				return {
					productNotice:{},
					productList:[],
					fileList:[],
					rules: {
						title: [
							{ required: true, message: '请输入产品公告标题', trigger: 'blur'  }
						],
						description: [
							{ required: true, message: '请输入产品公告内容', trigger: 'blur'  }
						],
						publishtime: [
							{ required: true, message: '请输入产品发布日期', trigger: 'blur'  }
						],
						// productId: [
						// 	{ required: true, message: '请选择产品', trigger: 'blur' }
						// ],
					},
					loading:false,
					mainStyleObject:{
						"height":window.innerHeight-170+"px",
						"overflow-y":"auto",
						"padding":"20px 10px 10px 10px",
						"box-sizing":"border-box"
					}
				}
			},
			mounted:function () {
				this.listProduct();
				var productNoticeId = this.$route.params.productnoticeid;
				if(productNoticeId != null ){
					this.getProductNoticeDetail(productNoticeId);
				}

			},
			methods:{
				getUploadUrl:function () {
					return uploadUrl;
				},
				uploadSuccess:function (response, file, fileList) {
					var fileObj = {};
					fileObj.name = response.noticeFile.fileName;
					fileObj.url = response.noticeFile.url;
					fileObj.id = response.noticeFile.id;
					this.fileList.push(fileObj);
				},
				removeSuccess:function (file, fileList) {
					for(var i=this.fileList.length-1;i>=0;i--){
						var fileOri = this.fileList[i];
						if(fileOri.id == file.id){
							this.fileList.splice(i,1);
						}
					}
				},
				getProductNoticeDetail:function (productNoticeId) {
					this.$http.get(getProductNoticeDetailUrl+"?id="+productNoticeId,{}).then(
						function(response){
							var defaultResult = this.responseDefaultHandle(response);
							if(defaultResult == false )
								return;
							var res = response.body;
							if(res.result==1){
								this.productNotice = res.object;
								//处理fileList
								var fileList = [];
								for(var i=0;i<this.productNotice.notileFileList.length;i++){
									var file = this.productNotice.notileFileList[i];
									var fileObj = {};
									fileObj.name = file.noticeFile.fileName;
									fileObj.url = file.noticeFile.url;
									fileObj.id = file.noticefileId;
									fileList.push(fileObj);
								}
								this.fileList = fileList;
							}else{
								this.$message.error(res.emsg);
							}
						},function(){
							this.$message.error("获取产品详情失败");
						})
				},
				listProduct(){
					axios({
						method: 'post',
						url:config.host+'/backend/product/list.json',
						data:{start:0,size:99,netValue:false,hasCategory:true}
					}).then((response)=>{
						var defaultResult = this.responseDefaultHandle(response);
						if(defaultResult == false )
							return;
						if(response.data.result == 1){
							this.productList = response.data.items;
							var defaultOption = {id:0,name:"全部产品"};
							this.productList.splice(0,0,defaultOption);
						}else{
							this.$alert(response.data.emsg, '请求失败', {
								confirmButtonText: '确定'
							});
						}
						this.operating = false;
						console.log(response.data)
					}).catch((error)=>{
						this.operating = false;
						this.$alert(error.response.statusText, '请求失败', {
							confirmButtonText: '确定'
						});
					})
				},
				submit:function () {
					this.$refs.form.validate((valid) => {
						if (valid) {
							var productNotice = JSON.parse(JSON.stringify(this.productNotice));
							this.operating = true;
							var noticeFileIds = [];
							for(var i=0;i<this.fileList.length;i++){
								var file = this.fileList[i];
								noticeFileIds.push(file.id);
							}
							productNotice.notileFileIdList = noticeFileIds;
							if(productNotice.productId == 0 ){
								delete productNotice.productId;
							}
							axios({
								method: 'post',
								url:config.host+'/backend/productnotice/update.json',
								data:productNotice
							}).then((response)=>{
								var defaultResult = this.responseDefaultHandle(response);
								if(defaultResult == false )
									return;
								if(response.data.result == 1){
									this.$message({
										message: '更新成功',
										type: 'success'
									});
									this.$router.back();
								}else{
									this.$alert(response.data.emsg, '更新失败', {
										confirmButtonText: '确定'
									});
								}
								this.operating = false;
								console.log(response.data);
							}).catch((error)=>{
								this.operating = false;
								this.$alert(error.response.statusText, '更新失败', {
									confirmButtonText: '确定'
								});
							})
						} else {
							return false;
						}
					});
				},
			}
    }
</script>

<style scoped>
	.title{
		border-bottom: 1px solid #ddd;
		padding: 10px;
	}
</style>



// WEBPACK FOOTER //
// src/layouts/productnotice/EditProductNotice.vue